import React from 'react';
import PaymentActions from './PaymentActions';
const categories:Record<string,string>={acv:'Deposit',deductible:'Deductible',depreciation:'Final Payment',supplement:'Supplement',other:'Other'};
const payers:Record<string,string>={customer:'Customer',insurer:'Insurer',other:'Other payer'};
export default function RecordedPayment(props:React.ComponentProps<typeof PaymentActions>) {
  const {receipt,payment}=props;
  const source=receipt || payment;
  const method=(source.payment_method || payment?.payment_method || '').replace(/_/g,' ');
  const reference=receipt ? receipt.check_number : payment?.reference_number;
  const date=(receipt ? receipt.received_date : payment?.payment_date)?.slice(0,10);
  const details=[receipt ? categories[receipt.check_type] : null,payers[source.payer_type],method,reference ? `#${reference}` : null].filter(Boolean).join(' · ');
  return <div style={{background:'#243447',borderRadius:10,padding:14,display:'flex',alignItems:'center',gap:12,flexWrap:'wrap'}}>
    <div style={{flex:'1 1 200px',minWidth:0}}>
      <div style={{color:'#fff',fontSize:14,fontWeight:600}}>{payment?.payment_number || 'Payment'}</div>
      <div style={{color:'#8FA8C0',fontSize:12,textTransform:'capitalize',marginTop:3}}>{details}</div>
      <div style={{color:'#8FA8C0',fontSize:11,marginTop:3}}>{date ? `Received ${new Date(`${date}T12:00:00`).toLocaleDateString()}` : 'Date not recorded'}{source.notes || source.internal_note ? ` · ${source.notes || source.internal_note}` : ''}</div>
      {receipt?.deposited_date && <span style={{display:'inline-block',marginTop:4,color:'#10B981',fontSize:11,fontWeight:600}}>✓ Deposited</span>}
    </div>
    <strong style={{color:'#10B981',fontSize:18,whiteSpace:'nowrap'}}>{Number(source.amount).toLocaleString('en-US',{style:'currency',currency:'USD'})}</strong>
    <PaymentActions {...props}/>
  </div>;
}
